"use client";
import { useAtomValue } from "jotai";
import { cursorAtom, isViewOnlyModeAtom } from "@zapier/canvas-state";

import { Canvas } from "../components/Canvas";
import { MultiSelectPanel } from "../components/MultiSelectPanel";
import { CanvasBackground } from "../components/CanvasBackground";

import styles from "./IframeEmbeddedCanvas.module.css";

export function CanvasById() {
  const cursorMode = useAtomValue(cursorAtom);
  const isViewOnlyMode = useAtomValue(isViewOnlyModeAtom);

  return (
    <div className={styles.wrapper}>
      {cursorMode !== "add-group" && !isViewOnlyMode && <MultiSelectPanel />}
      <Canvas>
        <CanvasBackground />
      </Canvas>
    </div>
  );
}
